import Gmodal from 'glory-modal';

export default () => {

    let requestQuoteModalEl = document.getElementById('requestQuoteModal');
    let requestQuoteBtn = document.getElementById('header-requestquote-btn');
    let requestQuoteBtnMobile = document.getElementById('header-requestquote-btn-mobile');

    if (!requestQuoteBtn || !requestQuoteBtnMobile || !requestQuoteModalEl) {
        return;
    }

    const requestQuoteModal = new Gmodal(requestQuoteModalEl, {
        stickySelectors: [],
        animation: true,
        backdrop: true,
        closeBackdrop: true,
        keyboard: true
    });

    requestQuoteBtn.addEventListener('click', (e) => {
        e.preventDefault();
        requestQuoteModal.open();
    });

    requestQuoteBtnMobile.addEventListener('click', (e) => {
        e.preventDefault();
        requestQuoteModal.open();
    });

    // Show the hubspot form
    requestQuoteModalEl.addEventListener('gmodal:beforeopen', function(evt) {

        hbspt.forms.create({
            region: "na1",
            target: '#requestQuoteForm',
            portalId: "5257953",
            formId: "760a48cf-dc08-43b1-9ca5-fa4e0e68531d"            
        });

    });

}